import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { usePool } from '../context/PoolContext';
import pickNPrayLogo from '../Logos/LogoNoText cropped.png';

function BottomTabBar({ isLive }) {
  const location = useLocation();
  const navigate = useNavigate();
  const { isAuthenticated, logout } = useAuth();
  const { totalUnread, selectedPoolId } = usePool();
  const [menuOpen, setMenuOpen] = useState(false);

  const isActive = (path) => location.pathname === path;

  if (!isAuthenticated) {
    return (
      <nav className="bottom-tab-bar">
        <Link to="/login" className={`bottom-tab ${isActive('/login') ? 'bottom-tab-active' : ''}`}>
          <div className="bottom-tab-icon">
            <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4" />
              <polyline points="10 17 15 12 10 7" />
              <line x1="15" y1="12" x2="3" y2="12" />
            </svg>
          </div>
          <span className="bottom-tab-label">Log In</span>
        </Link>
        <Link to="/register" className={`bottom-tab ${isActive('/register') ? 'bottom-tab-active' : ''}`}>
          <div className="bottom-tab-icon">
            <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
              <circle cx="8.5" cy="7" r="4" />
              <line x1="20" y1="8" x2="20" y2="14" />
              <line x1="23" y1="11" x2="17" y2="11" />
            </svg>
          </div>
          <span className="bottom-tab-label">Sign Up</span>
        </Link>
      </nav>
    );
  }

  const handleMenuLink = (path) => {
    setMenuOpen(false);
    navigate(path);
  };

  return (
    <>
      {/* Overlay menu that pops up from center button */}
      {menuOpen && (
        <div className="bottom-menu-overlay" onClick={() => setMenuOpen(false)}>
          <div className="bottom-menu-sheet" onClick={e => e.stopPropagation()}>
            <button className="bottom-menu-item" onClick={() => handleMenuLink(selectedPoolId ? `/pool/${selectedPoolId}/picks` : '/dashboard')}>
              <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M9 11H5a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7a2 2 0 0 0-2-2h-4" />
                <rect x="9" y="2" width="6" height="4" rx="1" ry="1" />
                <path d="M9 14l2 2 4-4" />
              </svg>
              My Picks
            </button>
            <button className="bottom-menu-item" onClick={() => handleMenuLink('/live')}>
              <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M18 20V10" /><path d="M12 20V4" /><path d="M6 20v-6" />
              </svg>
              {isLive ? 'Live Boards' : 'Leaderboards'}
            </button>
            <button className="bottom-menu-item" onClick={() => handleMenuLink('/lock-sheet')}>
              <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
                <path d="M7 11V7a5 5 0 0 1 10 0v4" />
              </svg>
              Lock Sheet
            </button>
            <button className="bottom-menu-item" onClick={() => handleMenuLink('/join')}>
              <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                <circle cx="8.5" cy="7" r="4" />
                <line x1="20" y1="8" x2="20" y2="14" />
                <line x1="23" y1="11" x2="17" y2="11" />
              </svg>
              Join Pool
            </button>
            <button className="bottom-menu-item" onClick={() => handleMenuLink('/badges')}>
              <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="12" cy="8" r="7" />
                <polyline points="8.21 13.89 7 23 12 20 17 23 15.79 13.88" />
              </svg>
              Badges
            </button>
            <button className="bottom-menu-item bottom-menu-item-danger" onClick={async () => { setMenuOpen(false); await logout(); navigate('/'); }}>
              <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
                <polyline points="16 17 21 12 16 7" />
                <line x1="21" y1="12" x2="9" y2="12" />
              </svg>
              Log Out
            </button>
          </div>
        </div>
      )}

      <nav className="bottom-tab-bar">
        {/* Home */}
        <Link to="/dashboard" className={`bottom-tab ${isActive('/dashboard') ? 'bottom-tab-active' : ''}`}>
          <div className="bottom-tab-icon">
            <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
              <polyline points="9 22 9 12 15 12 15 22" />
            </svg>
          </div>
          <span className="bottom-tab-label">Home</span>
        </Link>

        {/* Corner Chat */}
        <Link to="/corner-chat" className={`bottom-tab ${isActive('/corner-chat') ? 'bottom-tab-active' : ''}`}>
          <div className="bottom-tab-icon">
            <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
            </svg>
            {totalUnread > 0 && (
              <span className="bottom-tab-unread">{totalUnread > 9 ? '9+' : totalUnread}</span>
            )}
          </div>
          <span className="bottom-tab-label">Chat</span>
        </Link>

        {/* Center Menu Button */}
        <button
          className={`bottom-tab bottom-tab-center ${menuOpen ? 'bottom-tab-active' : ''}`}
          onClick={() => setMenuOpen(prev => !prev)}
        >
          <div className="bottom-tab-center-btn">
            <img src={pickNPrayLogo} alt="Menu" style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '50%' }} />
          </div>
        </button>

        {/* Create Pool */}
        <Link to="/create-pool" className={`bottom-tab ${isActive('/create-pool') ? 'bottom-tab-active' : ''}`}>
          <div className="bottom-tab-icon">
            <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="12" cy="12" r="10" />
              <line x1="12" y1="8" x2="12" y2="16" />
              <line x1="8" y1="12" x2="16" y2="12" />
            </svg>
          </div>
          <span className="bottom-tab-label">Create</span>
        </Link>

        {/* Profile / Settings */}
        <Link to="/profile" className={`bottom-tab ${isActive('/profile') ? 'bottom-tab-active' : ''}`}>
          <div className="bottom-tab-icon">
            <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
              <circle cx="12" cy="7" r="4" />
            </svg>
          </div>
          <span className="bottom-tab-label">Profile</span>
        </Link>
      </nav>
    </>
  );
}

export default BottomTabBar;
